import {
  ChatMessageSettings,
  ChatMessageSettingsType,
} from '@/components/admin/beneficiary-app/ChatMessageSettings'
import { adminStoreActions } from '@/store/actions'
import { useStoreDispatch } from '@/store/hooks'
import { Organization } from '@/store/user'

export function ChatMessageSettingsRoute({ organization }: { organization: Organization }) {
  const dispatch = useStoreDispatch()
  return (
    <ChatMessageSettings
      initialValues={{
        assistantName: organization.chatAssistantName,
        answerGoal: organization.chatAnswerGoal,
        messageInstructions: organization.chatMessageInstructions,
        safetyRules: organization.chatSafetyRules,
      }}
      onChatMessageSettingsUpdated={(chatMessageSettings: ChatMessageSettingsType) => {
        void dispatch(
          adminStoreActions.organization.update({
            fields: { ...chatMessageSettings },
          }),
        )
      }}
    />
  )
}
